import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  HostListener,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { prevTaskService } from 'src/app/services/prev-task.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { TechnicianService } from '../../../services/technician.service';
import { PrevTaskDialogComponent } from '../prev-task-dialog/prev-task-dialog.component';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { MatTableDataSource } from '@angular/material/table';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { ActionEditDeleteBtnRendererTechnicianSubTask } from 'src/app/action-edit-delete-btn-renderer-technician-sub-task.component';
import { ActionEditDeleteBtnRendererPrevTaskForm } from 'src/app/action-edit-delete-btn-renderer-prev-task-form.component';
import { AgGridAngular } from 'ag-grid-angular';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ExternalVendorRendererComponent } from 'src/app/external-vendor-renderer.component';
import { TechnicianRendererComponent } from 'src/app/technician-renderer.component';
import { TechScoreService } from 'src/app/services/tech-score.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { PrevTaskChecklistExecutionComponent } from '../prev-task-checklist-execution/prev-task-checklist-execution.component';
import { UserConfigurationsService } from 'src/app/services/user-configurations.service';
@Component({
  selector: 'app-prev-task-form',
  templateUrl: './prev-task-form.component.html',
  styleUrls: ['./prev-task-form.component.scss'],
})
export class PrevTaskFormComponent implements OnInit {
  private readonly tabletBreakpoint = 1024;
  @ViewChild(PrevTaskChecklistExecutionComponent, { static: false })
  checklistComponent!: PrevTaskChecklistExecutionComponent;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('technicianimageModal')
  private technicianimageModal!: TemplateRef<any>;
  @ViewChild('subTaskDialog') private subTaskDialog!: TemplateRef<any>;
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  display = 'none';
  isEdit: boolean = false;
  edited: boolean = false;
  languageDir = 'ltr';
  preTaskForm: any;
  imageFile: any;
  imageFileName: any;
  blobStorageUrl: string = '';
  spinnerText: string = '';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  minDate!: Date;
  maxDate: Date = new Date();

  disableStartTime: boolean = false;
  preTask: any = {
    MachineName: '',
    TaskName: '',
    FrequencyName: '',
    TaskDesc: '',
    Duration: '',
    Status: '',
    StartTime: new Date(),
    FinishTime: '',
    Remarks: '',
    ItemCode: '',
    ItemName: '',
    ItemDesc: '',
    MeterReading: '',
    SparePartsUsed: '',
    WorkLog: '',
    UploadPicture: [],
    CreatedAt: '',
    CreatedBy: 0,
    ID: 0,
  };
  StatusList = [
    { ID: 0, Value: 'Not Done' },
    { ID: 1, Value: 'Done' },
  ];
  EditItemDetails = {
    ItemName: '',
    ItemCode: '',
    ItemDesc: '',
  };
  isImageFile: boolean = false;
  isVideoFile: boolean = false;
  TaskFiles: any = [];
  toggleChecked: boolean = false;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('toggleElement') ref: any;
  imageSrc = new Array<string>();
  fileType: any;
  FileData: any = [];
  FileList: any = [];
  EditFileData: any = [];
  isviewMode: any;
  plantSession: any;
  groupSession: any;
  userSession: any;
  isAccess = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_ACCESS;
  isWrite = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_CREATE;
  isUpdate = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_UPDATE;
  isDelete = ApplicationPermission.TECHNITOIN_EXECUTION_LIST_DELETE;
  isSubTaskSaved: boolean = false;

  subTaskForm: FormGroup;
  subTasksArray: any[] = [];
  subtaskFormMode: boolean = true; // True for add, false for edit
  subTaskRowIndex: number | null = null;
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  rowData: any[] | any = [];
  frameworkComponents: any;
  gridOptions: any = {
    defaultColDef: {
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true,
      filter: 'agSetColumnFilter',
    },
    context: {
      componentParent: this,
    },
    suppressCellSelection: true,
  };

  externalWorkColumns: string[] = [
    'parameter',
    'target',
    'tiggerAt',
    'date',
    'actual',
  ];
  meterReadingData = new MatTableDataSource<any>([]);

  technicians: any[] | any = [];

  vendors: any[] = [];

  vendorMode: string = 'existing';

  @ViewChild('vendorElement') vendorElement: any;

  vendorToggle: boolean = false;
  user: any;
  groupCode: any;
  plantCode: any;
  userId: any;
  technicianTaskId: number;
  technicianExecutionWOID: number = 0;
  userCode: any;
  taskId: number;
  private woSubscription!: Subscription;

  taskStatus: string = '';

  woObject: any;

  checklistScore: number = 0;

  disableFinishTime: boolean = true;
  touchUi = false;

  showSubmit: boolean = false;
  filteredTechnicianList: any;
  vendorsList: any[];
  workLogForm: FormGroup;
  savedWorkLogs: any[] = [];
  editingIndex: number | null = null;

  constructor(
    private toaster: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    public datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private prevTaskService: prevTaskService,
    private baseApi: BaseApi,
    public dialog: MatDialog,
    public translater: TranslaterService,
    public translate: TranslateService,
    private technicianService: TechnicianService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private techScoreService: TechScoreService,
    private userConfigService: UserConfigurationsService,
    private PrevConfigurationService: PrevConfigurationService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    const nav = this.router.getCurrentNavigation();
    const id = nav?.extras?.queryParams?.['technicianTaskId'];

    this.minDate = new Date();
    this.minDate.setHours(0);
    this.minDate.setMinutes(0);
    this.minDate.setSeconds(0);
    this.preTaskForm = this.fb.group({
      MachineName: [{ value: '', disabled: true }],
      TaskName: [{ value: '', disabled: true }],
      FrequencyName: [{ value: '', disabled: true }],
      TaskDesc: [{ value: '', disabled: true }],
      Duration: [{ value: '', disabled: true }],
      status: [{ value: '', disabled: true }, Validators.required],
      startTime: [new Date(), Validators.required],
      finishTime: [''],
      remarks: [''],
      itemname: [''],
      itemcode: [''],
      itemdesc: [''],
      meterreading: [''],
      sparepartsused: [''],
      worklog: [''],
    });

    this.subTaskForm = this.fb.group({
      Id: [],
      woDetails: ['', Validators.required],
      responsible: ['', Validators.required],
      externalVendor: [''],
      newVendorName: [''],
      targetDate: ['', Validators.required],
    });

    this.workLogForm = this.fb.group({
      workLog: this.fb.group({
        title: ['', [Validators.required, Validators.maxLength(200)]],
      }),
    });
    this.frameworkComponents = {
      ActionEditDeleteBtnRendererPrevTaskForm:
        ActionEditDeleteBtnRendererPrevTaskForm,
      ExternalVendorRendererComponent: ExternalVendorRendererComponent,
      TechnicianRendererComponent: TechnicianRendererComponent,
    };
  }

  ngOnInit(): void {
    this.updateResponsiveControls();
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.getLangWords();

    this.woSubscription = this.technicianService
      .getWObject()
      .subscribe((wo: any) => {
        if (wo) {
          this.woObject = {};
          this.woObject = wo;
          this.isEdit = true;
          // this.populateForm(wo);
        }
      });

    this.technicianTaskId = this.woObject.ID;

    this.getExternalWorkData();
    this.blobStorageUrl = Constants.BLOB_STORAGE_URL;
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();

    this.getTechnicianTaskValues();
    this.getMeterReadings();
    this.getSessionData();
    this.getTechnicians();
    this.getVendors();

    if (this.woObject.Task.ChecklistIds) {
      this.GetQualityCheckListExecPMData(
        this.woObject.Task.ChecklistIds,
        this.woObject.ID
      );
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateResponsiveControls();
  }

  private updateResponsiveControls(): void {
    this.touchUi =
      typeof window !== 'undefined' && window.innerWidth <= this.tabletBreakpoint;
  }

  disablePastDates = (date: Date | null): boolean => {
    if (!date) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return date >= today;
  };

  get workLog(): FormGroup {
    return this.workLogForm.get('workLog') as FormGroup;
  }

  addWorkLog(): void {
    this.saveCurrentWorkLog();
  }

  saveCurrentWorkLog(): void {
    if (this.workLog.valid) {
      const logValue = { ...this.workLog.value };

      if (this.editingIndex !== null) {
        // Update the existing item
        this.savedWorkLogs[this.editingIndex] = logValue;
        this.editingIndex = null;
      } else {
        // Add a new item
        this.savedWorkLogs.push(logValue);
      }

      this.workLog.reset();
    } else {
      this.workLog.markAllAsTouched();
    }
  }

  editWorkLog(index: number): void {
    const log = this.savedWorkLogs[index];

    this.workLog.setValue({ title: log.title });
    this.editingIndex = index;
  }

  removeWorkLog(index: number): void {
    this.savedWorkLogs.splice(index, 1);

    // Cancel edit if the deleted item is the one being edited
    if (this.editingIndex === index) {
      this.resetWorkLogForm();
    }

    // Adjust editingIndex if it’s after the removed index
    else if (this.editingIndex !== null && index < this.editingIndex) {
      this.editingIndex--;
    }
  }

  resetWorkLogForm(): void {
    this.workLog.reset();
    this.editingIndex = null;
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.addWorkLog();
    }
  }

  getSessionData(): void {
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupCode = this.groupSession.groupCode;
    this.plantCode = this.plantSession.plantCode;
    this.user = this.baseApi.getUserSession();
    this.userId = this.user.userId;
    this.userCode = this.user.userCode;
  }

  onPanelClose(isOpen: boolean, type: string, inputElement: HTMLInputElement) {
    if (!isOpen) {
      // Reset the search input value
      inputElement.value = '';

      switch (type) {
        case 'tech':
          this.filteredTechnicianList = [...this.technicians];
          break;
        case 'vender':
          this.vendorsList = [...this.vendors];
          break;
      }
    }
  }
  searchValues(event: any, type: string) {
    const filter = event.target.value.toLowerCase();
    switch (type) {
      case 'tech':
        this.filteredTechnicianList = this.technicians.filter((tech) =>
          tech.name.toLowerCase().includes(filter)
        );
        break;
      case 'vender':
        this.vendorsList = this.vendors.filter((ven) =>
          ven.Name.toLowerCase().includes(filter)
        );
        break;
    }
  }
  getTechnicians(): void {
    if (!this.plantCode) {
      console.warn('Plant code is not available');
      this.technicians = [];
      return;
    }

    const key = {
      Plant: this.plantSession?.plantCode,
    };

    this.techScoreService.getAllTechScoreList(key).subscribe({
      next: (res: any[]) => {
        // Remove duplicates based on TechId or EmployeeCode
        const uniqueTechnicians = Array.from(
          new Map(
            res.map((item) => [
              item.TechId || item.EmployeeCode,
              {
                id: item.TechId || item.EmployeeCode,
                name: item.full_name,
              },
            ])
          ).values()
        );

        this.technicians = uniqueTechnicians;
        this.filteredTechnicianList = this.technicians; // Initialize filtered list with all technicians
        console.log('Technicians loaded:', this.technicians);
      },
      error: (err) => {
        console.error('Error fetching technicians:', err);
        this.technicians = [];
      },
    });
  }

  getVendors() {
    const data = {
      PlantCode: this.plantCode,
      GroupCode: this.groupCode,
    };
    this.prevTaskService.getPMExternalVendor(data).subscribe((res: any) => {
      this.vendors = res.data;
      this.vendorsList = this.vendors;
      this.cdr.detectChanges();
    });
  }

  getExternalWorkColumns() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        headerValueGetter: this.localizeHeader.bind(this),
        cellRenderer: 'ActionEditDeleteBtnRendererPrevTaskForm',
        cellRendererParams: {
          onClickEdit: this.editRow.bind(this),
          onClickDelete: this.deleteRow.bind(this),
          onClickView: this.viewRow.bind(this),
          isUpdate: this.isUpdate, // <--- pass it
          isDelete: this.isDelete, // <--- pass it
        },
        pinned: 'left',
        width: 120,
      },
      {
        headerName: 'WO Details',
        field: 'woDetails',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Responsible',
        field: 'responsible',
        width: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'External Vendor',
        field: 'externalVendor',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        field: 'status',
        cellStyle: (params) => {
          if (params.value === 'Pending') {
            return {
              backgroundColor: '#FFFF00',
              color: 'black',
              fontWeight: 'bold',
            };
          } else if (params.value === 'Completed') {
            return {
              backgroundColor: '#38CF36',
              color: 'white',
              fontWeight: 'bold',
            };
          }
          return null;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Target Date',
        field: 'targetDate',
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateOnly') : '',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Completion Date',
        field: 'completionDate',
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : '',
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
  }

  getExternalWorkData(): void {
    if (!this.technicianTaskId) {
      this.rowData = [];
      return;
    }
    this.prevTaskService
      .getSubTaskWorkOrderByTaskId(
        this.technicianTaskId,
        this.technicianExecutionWOID
      )
      .subscribe({
        next: (res: any[]) => {
          this.rowData = res.map((item) => ({
            id: item.Id,
            woDetails: item.Detail,
            responsible:
              this.getResponsibleName(item.ResponsibleID) ||
              item.ResponsibleName ||
              item.ResponsibleID,
            responsibleId: item.ResponsibleID,
            externalVendor: item.externalVendor,
            externalVendorId: item.ExternalVendorId,
            status: item.Status,
            targetDate: item.TargetDate ? item.TargetDate : null,
            completionDate: item.CompletionDate ? item.CompletionDate : null,
          }));
          if (this.rowData.length > 0) {
            this.disableFinishTime = this.rowData.some(
              (item) => item.status === 'Pending'
            );
          }
          // Refresh grid after data update
          if (this.gridApi) {
            this.gridApi.setRowData(this.rowData);
            this.gridApi.refreshCells({ force: true });
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.rowData = [];
          this.cdr.detectChanges();
        },
      });
  }

  formatCellData(value: any, formatType: string): string {
    return this.userConfigService.formatField(value, formatType);
  }

  getVenderName(ExternalVendor: string): string {
    const vender = this.vendors.find((tech) => tech.id === ExternalVendor);
    return vender ? vender.id : '';
  }
  getResponsibleName(responsibleId: string): string {
    const technician = this.technicians.find(
      (tech) => tech.id === responsibleId
    );
    return technician ? technician.name : '';
  }

  ngAfterViewInit(): void {
    this.ensureGridReady();
    setTimeout(() => {
      this.getChecklistData();
    }, 8000);
  }

  getMeterReadings(): void {
    if (this.technicianTaskId) {
      this.technicianService
        .getTechnicianTaskParametertargetBytechnicianId(this.technicianTaskId)
        .subscribe(
          (response: any[]) => {
            // Ensure TechnicianTaskId is set if it's null
            const updatedResponse = response.map((item) => {
              if (!item.TechnicianTaskId) {
                item.TechnicianTaskId = this.technicianTaskId;
              }
              return item;
            });

            this.meterReadingData.data = updatedResponse;
            this.getPaginator();
          },
          (error) => {
            console.log('Error fetching meter readings:', error);
          }
        );
    }
    this.getPaginator();
  }

  actualChange(event: any, element: any): void {
    const newValue = Number(event.target.value);
    const index = this.meterReadingData.data.findIndex(
      (item) => item === element
    );
    if (index > -1) {
      this.meterReadingData.data[index].Actual = newValue;
      this.meterReadingData._updateChangeSubscription();
    }
    this.getChecklistData();
  }

  getPaginator(): void {
    setTimeout(() => {
      this.meterReadingData.paginator = this.paginator.first;
      this.meterReadingData.sort = this.sort.first;
    }, 1000);
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.index === 5) {
      this.ensureGridReady();
      this.updateGridData();
    }
    this.resetUnsavedSubTaskForm();
    // if (event.index === 3) {
    //   this.loadAllWorkLogs();
    // }
  }

  updateGridData() {
    if (this.gridApi) {
      this.gridApi.setRowData(this.rowData);
      this.gridApi.refreshCells({ force: true });
    }
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.rowData);
    this.gridApi.sizeColumnsToFit();
  }

  ensureGridReady() {
    if (!this.agGrid || !this.agGrid.api) {
      return;
    }
    this.gridApi = this.agGrid.api;
    this.gridColumnApi = this.agGrid.columnApi;
    this.gridApi.setRowData(this.rowData);
    this.gridApi.refreshCells({ force: true });
    this.gridApi.sizeColumnsToFit();
  }

  resetUnsavedSubTaskForm(): void {
    if (!this.isSubTaskSaved && this.subTaskForm.dirty) {
      this.resetForm();
      this.dialog.closeAll();
    }
  }

  openWOdialog(): void {
    this.subtaskFormMode = true;
    this.isSubTaskSaved = false;
    this.resetForm();
    const dialogRef = this.dialog.open(this.subTaskDialog, {
      height: 'auto',
      width: '90%',
      data: { technicianTaskId: this.technicianTaskId }, // Pass technicianTaskId if needed
    });

    dialogRef.afterClosed().subscribe(() => {
      if (!this.isSubTaskSaved) {
        this.resetForm();
      }
      this.updateGridData();
      this.getChecklistData();
      this.cdr.detectChanges();
    });
  }

  isSubmitting: boolean = false;
  submitForm(): void {
    if (this.subTaskForm.invalid) {
      return;
    }
    this.spinner.show();
    this.isSubmitting = true;

    const formValue = this.subTaskForm.value;

    const isNewVendor = this.vendorMode === 'new';
    const isExistingVendor = this.vendorMode === 'existing';

    const externalVendor =
      isNewVendor && formValue.newVendorName?.trim()
        ? formValue.newVendorName.trim()
        : null;

    const externalVendorId =
      isExistingVendor && formValue.externalVendor
        ? this.vendors.find((v) => v.Id === formValue.externalVendor)?.Id
        : null;

    // Format targetDate to ISO string
    const targetDate = formValue.targetDate
      ? new Date(formValue.targetDate).toISOString()
      : null;

    const payload = {
      Id: formValue.Id,
      TechnicianTaskId: this.woObject.ID,
      TaskId: this.woObject.Task.ID,
      Detail: formValue.woDetails,
      ResponsibleID: formValue.responsible,
      ExternalVendor: externalVendor, // string if new vendor
      ExternalVendorId: externalVendorId, // ID if existing vendor
      TargetDate: targetDate,
      CompletionDate: null,
      Status: 'Pending',
      RMPM: 'PM',
      PlantCode: this.plantCode,
      GroupCode: this.groupCode,
      UserCode: this.userCode,
    };

    const request$ =
      payload.Id > 0
        ? this.prevTaskService.updateSubTaskWorkOrder(payload) // You need to implement this
        : this.prevTaskService.addSubTaskWorkOrder(payload);
    request$.subscribe({
      next: (response: string) => {
        this.spinner.hide();
        if (payload.Id) {
          this.toaster.success('SubTask  Work Order Updated Successfully');
        } else {
          this.toaster.success('SubTask Work Order Saved Successfully');
        }
        this.isSubTaskSaved = true;
        this.resetForm();
        this.dialog.closeAll();
        this.technicianTaskId = payload.TechnicianTaskId;
        this.getExternalWorkData();
        this.isSubmitting = false;
        this.cdr.detectChanges();
        externalVendorId === null ? this.getVendors() : null;
      },
      error: (err) => {
        this.spinner.hide();
        this.isSubmitting = false;
        this.cdr.detectChanges();
      },
    });
  }

  resetForm(): void {
    this.subTaskForm.reset();
    this.vendorToggle = false;
    this.vendorMode = 'existing';
    this.subTaskForm.patchValue({
      woDetails: '',
      responsible: '',
      externalVendor: '',
      newVendorName: '',
      targetDate: '',
    });
    this.subTaskForm.markAsPristine();
    this.subTaskForm.markAsUntouched();
  }

  editSubTask(element: any): void {
    this.subtaskFormMode = false;
    if (!element.externalVendorId && element.externalVendor) {
      this.vendorMode = 'new';
      this.vendorToggle = true;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: '',
        newVendorName: element.externalVendor,
      });
    } else {
      this.vendorMode = 'existing';
      this.vendorToggle = false;
      this.subTaskForm.patchValue({
        Id: element.id,
        woDetails: element.woDetails || '',
        responsible: element.responsibleId || '',
        targetDate: element.targetDate ? new Date(element.targetDate) : null,
        externalVendor: element.externalVendorId || '',
        newVendorName: '',
      });
    }

    this.cdr.detectChanges();
    setTimeout(() => {
      const dialogRef = this.dialog.open(this.subTaskDialog, {
        height: 'auto',
        width: '90%',
        disableClose: false,
      });

      dialogRef.afterClosed().subscribe(() => {
        if (!this.isSubTaskSaved) {
          this.resetForm();
        }
        this.cdr.detectChanges();
      });
    });
  }

  updateSubtaskForm(): void {
    if (this.subTaskForm.invalid) {
      return;
    }
    this.isSubmitting = true;
    const formValue = this.subTaskForm.value;
    // Determine ExternalVendor value
    const isNewVendor = this.vendorMode === 'new';
    const isExistingVendor = this.vendorMode === 'existing';

    const externalVendor =
      isNewVendor && formValue.newVendorName?.trim()
        ? formValue.newVendorName.trim()
        : null;

    const externalVendorId =
      isExistingVendor && formValue.externalVendor
        ? this.vendors.find((v) => v.Id === formValue.externalVendor)?.Id
        : null;

    // Format targetDate to ISO string
    const targetDate = formValue.targetDate
      ? new Date(formValue.targetDate).toISOString()
      : null;

    const payload = {
      Id: formValue.Id,
      TechnicianTaskId: this.woObject.ID,
      TaskId: this.woObject.Task.ID,
      Detail: formValue.woDetails,
      ResponsibleID: formValue.responsible,
      ExternalVendor: externalVendor, // string if new vendor
      ExternalVendorId: externalVendorId, // ID if existing vendor
      TargetDate: targetDate,
      CompletionDate: null,
      Status: 'Pending',
      RMPM: 'PM',
      PlantCode: this.plantCode,
      GroupCode: this.groupCode,
      UserCode: this.userCode,
    };

    const request$ = this.prevTaskService.updateSubTaskWorkOrder(payload);
    request$.subscribe({
      next: (response: string) => {
        if (payload.Id) {
          this.toaster.success('SubTask  Work Order Updated Successfully');
        }
        this.isSubTaskSaved = true;
        this.resetForm();
        this.dialog.closeAll();
        this.technicianTaskId = payload.TechnicianTaskId;
        this.getExternalWorkData();
        this.isSubmitting = false;
        this.cdr.detectChanges();
        externalVendorId === null ? this.getVendors() : null;
      },
      error: (err) => {
        this.isSubmitting = false;
        this.cdr.detectChanges();
      },
    });
  }

  editRow(element: any) {
    this.editSubTask(element.rowData);
  }

  deleteRow(element: any): void {
    const data = {
      Id: element.rowData.id,
      UserCode: this.userCode,
    };
    this.prevTaskService.deletePrevTask(data).subscribe({
      next: (res: string) => {
        this.toaster.success('SubTask Work Order deleted successfully.');
        this.getExternalWorkData();
      },
      error: (err) => { },
    });
  }

  viewRow(element: any): void {
    this.viewSubTask(element.rowData);
  }

  viewSubTask(element: any): void {
    this.subtaskFormMode = false;

    this.vendorMode = 'new';
    this.vendorToggle = true;
    this.subTaskForm.patchValue({
      Id: element.id,
      woDetails: element.woDetails || '',
      responsible: element.responsibleId || '',
      targetDate: element.targetDate ? new Date(element.targetDate) : null,
      externalVendor: '',
      newVendorName: element.externalVendor || element.externalVendorId,
    });


    // Disable all form fields for view mode
    this.subTaskForm.disable();

    this.cdr.detectChanges();
    setTimeout(() => {
      const dialogRef = this.dialog.open(this.subTaskDialog, {
        height: 'auto',
        width: '90%',
        disableClose: false,
      });

      dialogRef.afterClosed().subscribe(() => {
        // Re-enable the form after dialog closes
        this.subTaskForm.enable();
        this.resetForm();
        this.cdr.detectChanges();
      });
    });
  }

  imgview(data: any) {
    let dialogRef = this.dialog.open(this.technicianimageModal, {
      height: '90%',
      width: '90%',
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      this.getExternalWorkColumns();
    });
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  getTechnicianTaskValues() {
    var data = this.technicianService.getTechnicianTaskValues();
    if (data) {
      if (data.StartTime) {
        this.disableStartTime = true;
        this.minDate = new Date(data.StartTime ?? null);
      } else {
        this.disableStartTime = false;
        this.minDate = new Date(data.TaskExpireTime ?? null);
      }

      this.edited = true;
      this.isviewMode = data.isviewButton ?? null;

      let TaskUploadFiles: any = [];
      let TaskUploadFilesType: any = [];
      let UploadFiles: any = [];

      this.preTask.ID = data.ID ?? null;
      this.taskStatus = data.Status ?? null;
      this.preTask.Status = data.Status == 'Done' ? 1 : 0;
      this.preTask.StartTime = data.StartTime ?? new Date();
      this.preTask.FinishTime = data.FinishTime ?? null;
      this.preTask.Remarks = data.Remarks ?? null;
      this.preTask.ItemCode = data.ItemCode ?? null;
      this.preTask.ItemName = data.ItemName ?? null;
      this.preTask.ItemDesc = data.ItemDesc ?? null;
      this.preTask.TaskName = data.Task?.WOType?.Name ?? null;
      this.preTask.FrequencyName = data.Task?.Frequency?.Name ?? null;
      this.preTask.TaskDesc = data.Task?.Description ?? null;
      this.preTask.Duration = data.Task?.Duration ?? null;
      this.preTask.MeterReading = data.MeterReading ?? null;
      this.preTask.SparePartsUsed = data.SparePartsUsed ?? null;

      // WorkLog parsing
      const parsedData = JSON.parse(data.WorkLog || '[]');
      if (
        Array.isArray(parsedData) &&
        parsedData.every((item) => item && typeof item.title === 'string')
      ) {
        this.savedWorkLogs = parsedData;
      } else {
        this.savedWorkLogs = [];
      }

      // Machine Name construction
      this.preTask.MachineName = '';
      this.preTask.MachineName += data.Task?.line?.plDesc ?? '';
      if (data.Task?.units) this.preTask.MachineName += '/' + (data.Task?.units?.puDesc ?? '');
      if (data.Task?.assembly) this.preTask.MachineName += '/' + (data.Task?.assembly?.assblyDesc ?? '');
      if (data.Task?.subAssembly) this.preTask.MachineName += '/' + (data.Task?.subAssembly?.sAsblyDesc ?? '');
      if (data.Task?.component) this.preTask.MachineName += '/' + (data.Task?.component?.componentName ?? '');

      // Task Files
      if (data.Task?.UploadFile && data.Task?.FileType) {
        TaskUploadFiles = data.Task.UploadFile.split(',');
        TaskUploadFilesType = data.Task.FileType.split(',');
        for (let i = 0; i < TaskUploadFiles.length; i++) {
          const fileName = TaskUploadFiles[i]?.trim() ?? '';
          const fileExtension = fileName
            .substring(fileName.lastIndexOf('.') + 1)
            .toLowerCase();

          this.TaskFiles.push({
            FileType: TaskUploadFilesType[i] ?? null,
            ImageSrc: TaskUploadFiles[i] ?? null,
            FileExtension: fileExtension ?? null,
          });
        }
      }

      // Uploaded pictures
      if (data.UploadPicture) {
        UploadFiles = data.UploadPicture.split(',');
        for (let i = 0; i < UploadFiles.length; i++) {
          this.EditFileData.push({ ImageSrc: UploadFiles[i] ?? null });
        }
      }

      // Checkbox check
      if (this.preTask.ItemName && this.preTask.ItemCode) {
        setTimeout(() => {
          this.ref.checked = true;
        }, 100);
      }

      this.taskId = data?.Task?.ID ?? null;
    } else {
      this.router.navigateByUrl('/PM/TechnicianExecutionWindow');
    }
  }


  openFile() {
    this.fileInput.nativeElement.click();
  }

  onToggleChange(event: any) {
    if (event.checked) {
      this.preTask.ItemName = this.EditItemDetails.ItemName;
      this.preTask.ItemCode = this.EditItemDetails.ItemCode;
      this.preTask.ItemDesc = this.EditItemDetails.ItemDesc;
      this.openDialog();
      this.preTaskForm = this.fb.group({
        status: [this.preTask.Status, Validators.required],
        startTime: [new Date(), Validators.required],
        finishTime: [this.preTask.FinishTime],
        remarks: [this.preTask.Remarks],
        itemname: [this.preTask.ItemName, Validators.required],
        itemcode: [this.preTask.ItemCode, Validators.required],
        itemdesc: [this.preTask.ItemDesc],
        meterreading: [this.preTask.MeterReading],
        sparepartsused: [this.preTask.SparePartsUsed],
        worklog: [this.preTask.WorkLog],
      });
    } else {
      this.EditItemDetails.ItemName = this.preTask.ItemName;
      this.EditItemDetails.ItemCode = this.preTask.ItemCode;
      this.EditItemDetails.ItemDesc = this.preTask.ItemDesc;
      this.preTask.ItemName = '';
      this.preTask.ItemCode = '';
      this.preTask.ItemDesc = '';
      this.preTaskForm = this.fb.group({
        status: [this.preTask.Status, Validators.required],
        startTime: [new Date(), Validators.required],
        finishTime: [this.preTask.FinishTime],
        remarks: [this.preTask.Remarks],
        itemname: [this.preTask.ItemName],
        itemcode: [this.preTask.ItemCode],
        itemdesc: [this.preTask.ItemDesc],
        meterreading: [this.preTask.MeterReading],
        sparepartsused: [this.preTask.SparePartsUsed],
        worklog: [this.preTask.WorkLog],
      });
    }
  }

  onVendorToggleChange(event: any) {
    if (event.checked) {
      this.vendorMode = 'new';
      this.vendorElement.nativeElement.focus();
    } else {
      this.vendorMode = 'existing';
    }
  }

  openDialog(): void {
    let dialogRef = this.dialog.open(PrevTaskDialogComponent, {
      disableClose: true,
      width: '500px',
      data: {
        ItemName: this.preTask.ItemName,
        ItemCode: this.preTask.ItemCode,
        ItemDesc: this.preTask.ItemDesc,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == undefined) {
        this.ref.checked = false;
        this.preTask.ItemName = '';
        this.preTask.ItemCode = '';
        this.preTask.ItemDesc = '';
        this.preTaskForm = this.fb.group({
          status: [this.preTask.Status, Validators.required],
          startTime: [new Date(), Validators.required],
          finishTime: [this.preTask.FinishTime],
          remarks: [this.preTask.Remarks],
          itemname: [this.preTask.ItemName],
          itemcode: [this.preTask.ItemCode],
          itemdesc: [this.preTask.ItemDesc],
          meterreading: [this.preTask.MeterReading],
          sparepartsused: [this.preTask.SparePartsUsed],
          worklog: [this.preTask.WorkLog],
        });
      } else {
        this.preTask.ItemName = result.ItemName;
        this.preTask.ItemCode = result.ItemCode;
        this.preTask.ItemDesc = result.ItemDesc;
        this.preTaskForm = this.fb.group({
          status: [this.preTask.Status, Validators.required],
          startTime: [new Date(), Validators.required],
          finishTime: [this.preTask.FinishTime],
          remarks: [this.preTask.Remarks],
          itemname: [this.preTask.ItemName, Validators.required],
          itemcode: [this.preTask.ItemCode, Validators.required],
          itemdesc: [this.preTask.ItemDesc],
          meterreading: [this.preTask.MeterReading],
          sparepartsused: [this.preTask.SparePartsUsed],
          worklog: [this.preTask.WorkLog],
        });
      }
    });
  }

  readFile(event: any) {
    const files = event.target.files;
    if (files) {
      for (let file of files) {
        if (file.type.match('image.*')) {
          this.fileType = 'image';
          this.FileList.push(file);
        } else {
          this.toaster.warning('Warning', 'File Format Not Valid');
          return;
        }
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageSrc = e.target.result;
          this.FileData.push({
            FileType: this.fileType,
            ImageSrc: this.imageSrc,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  }

  removeFile(i: any) {
    this.FileData.splice(i, 1);
    this.FileList.splice(i, 1);
  }

  deleteFile(i: any) {
    this.EditFileData.splice(i, 1);
    this.preTask.UploadPicture.push(i);
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
  }

  onPartiallySave(): void {
    this.submitTask(true);
  }

  onSubmit(): void {
    this.submitTask(false);
  }

  getChecklistData(): void {
    const checkInterval = setInterval(() => {
      const checklistData = this.checklistComponent?.alldata ?? [];

      if (Array.isArray(checklistData)) {
        clearInterval(checkInterval);

        const meterData = this.meterReadingData?.data;
        const rowData = this.rowData;
        const hasMeterData = Array.isArray(meterData) && meterData.length > 0;
        const hasRowData = Array.isArray(rowData) && rowData.length > 0;

        let isChecklistPerfect = true;
        if (checklistData.length > 0) {
          const checklistScore = this.calculateChecklistScore(checklistData);

          if (checklistScore !== null && checklistScore !== undefined) {
            this.checklistScore = Number.isInteger(checklistScore)
              ? checklistScore
              : parseFloat(checklistScore.toFixed(2));
          } else {
            this.checklistScore = 0;
          }

          isChecklistPerfect = this.checklistScore === 100;
        } else {
          this.checklistScore = 0;
          isChecklistPerfect = true;
        }

        const { remarks, finishTime } = this.preTaskForm.value;

        const isValidValue = (value: any): boolean =>
          value !== undefined && value !== null && value !== '';

        const isMeterReadingValid = hasMeterData
          ? meterData.every((item) => isValidValue(item?.Actual))
          : true;

        const areRemarksValid = isValidValue(remarks);
        const isFinishTimeValid = isValidValue(finishTime);

        const isRowDataCompleted = hasRowData
          ? rowData.every((item) => item?.status === 'Completed')
          : true;

        const allValid =
          isChecklistPerfect &&
          isMeterReadingValid &&
          areRemarksValid &&
          isRowDataCompleted;

        this.disableFinishTime = !allValid;
        if (this.disableFinishTime == true && !this.isviewMode) {
          this.preTask.FinishTime = '';
          this.preTaskForm.patchValue({ finishTime: null });
        }
        this.showSubmit = allValid && isFinishTimeValid;
      }
    }, 300);
  }

  calculateChecklistScore(data: any[]): number {
    const totalItems = data.length;
    if (totalItems === 0) return 0;

    const percentPerItem = 100 / totalItems;

    const validItems = data.filter((item) => {
      const hasExecution =
        item.Execution && Object.keys(item.Execution).length > 0;
      const exec = hasExecution ? item.Execution : item;

      const itemType = exec.itemType ?? item.ItemType;

      if (hasExecution) {
        if (itemType === 4 || itemType === 6) {
          const fileVal = exec.file ?? item.file;
          const catTypeVal = exec.catType ?? item.catType;
          return (
            (fileVal != null && fileVal !== '') ||
            (catTypeVal != null && catTypeVal !== '')
          );
        } else {
          const catTypeVal = exec.catType ?? item.catType;
          return catTypeVal != null && catTypeVal !== '';
        }
      } else {
        if (itemType === 4 || itemType === 6) {
          const fileeVal = exec.file ?? item.file;
          return fileeVal != null;
        } else {
          const catTypeVal = exec.catType ?? item.catType;
          return catTypeVal != null && catTypeVal !== '';
        }
      }
    });

    return validItems.length * percentPerItem;
  }

  submitTask(isPartialSave: boolean): void {
    if (this.preTaskForm.invalid) {
      this.preTaskForm.markAllAsTouched();
      this.toaster.warning('Warning', 'Please Fill All Required Fields');
      return;
    }

    const now = new Date().toISOString();
    this.preTask.CreatedAt = now;
    this.preTask.CreatedBy = this.userSession?.userCode;
    this.preTask.TaskBy = this.userSession?.userCode;
    this.preTask.Status = isPartialSave ? 0 : 1;
    this.preTask.IsPartialSave = isPartialSave;
    this.preTask.WorkLog = JSON.stringify(this.savedWorkLogs);
    this.preTask.StartTime = this.preTask.StartTime
      ? new Date(this.preTask.StartTime).toISOString()
      : now;
    // Clean UI fields
    [
      'MachineName',
      'TaskName',
      'FrequencyName',
      'TaskDesc',
      'Duration',
      'TaskUploadFile',
      'TaskUploadFileType',
    ].forEach((field) => delete this.preTask[field]);
    if (!this.preTask.StartTime) delete this.preTask.StartTime;
    if (!this.preTask.FinishTime) delete this.preTask.FinishTime;

    // Group checklistExecutions by checkListId
    const groupedExecutions = new Map<number, any>();

    if (
      this.checklistComponent.alldata &&
      this.checklistComponent.alldata.length > 0
    ) {
      this.checklistComponent.alldata.forEach((item) => {
        const exec =
          item.Execution && Object.keys(item.Execution).length > 0
            ? item.Execution
            : item;

        let actualValue = '';
        let catType = '';
        let file: any = null;

        if (exec.itemType === 4 || exec.itemType === 6) {
          file = exec.file ?? null;
        } else {
          switch (exec.itemType) {
            case 1:
            case 2:
            case 5:
              actualValue = exec.catType ?? '';
              catType = actualValue;
              break;
            case 3:
              const rawDate = exec.catType;
              actualValue = rawDate
                ? new Date(
                  Date.UTC(
                    new Date(rawDate).getFullYear(),
                    new Date(rawDate).getMonth(),
                    new Date(rawDate).getDate()
                  )
                ).toISOString()
                : '';
              catType = actualValue;
              break;
          }
        }

        // Build detail
        const detail = {
          executionDetailId: exec.executionDetailId ?? 0,
          checkListDetailId: exec.checkListDetailId ?? 0,
          actualValue,
          remarks: exec.remarks ?? '',
          itemTypeId: exec.itemType ?? 1,
          catType,
          file,
        };

        // Group by checkListId
        if (!groupedExecutions.has(item.checkListId)) {
          groupedExecutions.set(item.checkListId, {
            userCode: this.userCode,
            isPartialSave,
            unitId: item.unitId,
            checkListId: item.checkListId,
            taskId: this.woObject?.ID,
            executionId: exec.executionId ?? 0,
            executionDetails: [],
          });
        }

        groupedExecutions.get(item.checkListId).executionDetails.push(detail);
      });
    }

    const checklistExecutions = Array.from(groupedExecutions.values());

    // Build Parameter Executions
    const parameterExecutions = this.meterReadingData.data.map((item) => ({
      Id: item.Id ?? null,
      TechnicianTaskId: item.TechnicianTaskId ?? null,
      TaskId: item.TaskId ?? null,
      Actual: item.Actual ?? '',
      Target: item.Target ?? '',
      ParameterId: item.ParameterId ?? '',
      PlantCode: this.plantCode ?? '',
      GroupCode: this.groupCode ?? '',
      UpdatedBy: this.userCode ?? '',
    }));

    // Build FormData
    const formData = new FormData();
    [
      'Status',
      'StartTime',
      'Remarks',
      'ItemCode',
      'ItemName',
      'ItemDesc',
      'MeterReading',
      'SparePartsUsed',
      'WorkLog',
      'CreatedAt',
      'CreatedBy',
      'ID',
      'TaskBy',
      'FinishTime',
    ].forEach((field) => {
      formData.append(field, this.preTask[field]?.toString() ?? '');
    });
    formData.append('IsPartialSave', isPartialSave.toString());

    this.preTask.DeletePicture?.forEach((pic) =>
      formData.append('UploadPicture', pic)
    );
    this.FileList.forEach((file) => formData.append('image', file, file.name));

    // Append grouped checklist executions
    checklistExecutions.forEach((q, i) => {
      formData.append(
        `QualityChecklistExecutions[${i}].checkListId`,
        q.checkListId
      );
      formData.append(
        `QualityChecklistExecutions[${i}].executionId`,
        q.executionId
      );
      formData.append(`QualityChecklistExecutions[${i}].userCode`, q.userCode);
      formData.append(`QualityChecklistExecutions[${i}].unitId`, q.unitId);
      formData.append(`QualityChecklistExecutions[${i}].taskId`, q.taskId);
      formData.append(
        `QualityChecklistExecutions[${i}].isPartialSave`,
        q.isPartialSave
      );

      q.executionDetails.forEach((d, j) => {
        formData.append(
          `QualityChecklistExecutions[${i}].executionDetails[${j}].remarks`,
          d.remarks || ''
        );
        formData.append(
          `QualityChecklistExecutions[${i}].executionDetails[${j}].itemTypeId`,
          d.itemTypeId
        );
        formData.append(
          `QualityChecklistExecutions[${i}].executionDetails[${j}].checkListDetailId`,
          d.checkListDetailId
        );
        formData.append(
          `QualityChecklistExecutions[${i}].executionDetails[${j}].actualValue`,
          d.actualValue || ''
        );
        formData.append(
          `QualityChecklistExecutions[${i}].executionDetails[${j}].executionDetailId`,
          d.executionDetailId
        );
        formData.append(
          `QualityChecklistExecutions[${i}].executionDetails[${j}].catType`,
          d.catType || ''
        );
        if ((d.itemTypeId === 4 || d.itemTypeId === 6) && d.file) {
          formData.append(
            `QualityChecklistExecutions[${i}].executionDetails[${j}].file`,
            d.file
          );
        }
      });
    });

    // Append parameters
    parameterExecutions.forEach((p, i) => {
      formData.append(`ParameterExecutions[${i}].Id`, p.Id);
      formData.append(
        `ParameterExecutions[${i}].TechnicianTaskId`,
        p.TechnicianTaskId
      );
      formData.append(`ParameterExecutions[${i}].TaskId`, p.TaskId);
      formData.append(`ParameterExecutions[${i}].Actual`, p.Actual);
      formData.append(`ParameterExecutions[${i}].Target`, p.Target);
      formData.append(`ParameterExecutions[${i}].PlantCode`, p.PlantCode);
      formData.append(`ParameterExecutions[${i}].GroupCode`, p.GroupCode);
      formData.append(`ParameterExecutions[${i}].UpdatedBy`, p.UpdatedBy);
      formData.append(`ParameterExecutions[${i}].ParameterId`, p.ParameterId);
    });

    // Submit
    this.spinner.show();
    const request$ = this.edited
      ? this.prevTaskService.updatePrevTask(formData)
      : this.prevTaskService.addPrevTask(formData);

    request$.subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res) {
          if (this.edited) this.preTask.UploadPicture = [];
          this.toaster.success(
            `Task ${this.edited ? 'updated' : 'added'} successfully.`
          );
          this.router.navigateByUrl('/PM/TechnicianExecutionWindow');
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.toaster.error('Error', err.message || 'Submission failed');
      },
    });
  }

  dateChanged(val: string) {
    if (this.disableFinishTime) {
      this.toastr.warning(
        'Either you have not complete your Checklist or SubTasks or Add Paramerters Or Add Remarks'
      );
      this.preTask.FinishTime = null;
      this.preTaskForm.patchValue({ finishTime: null });
      return;
    }

    if (val === 'finishTime') {
      const finishTime = new Date(this.preTask.FinishTime);
      const startTime = new Date(this.preTask.StartTime);
      const currentTime = new Date();

      if (finishTime <= startTime) {
        this.toastr.warning(
          'Finish Time Should Not Be Prior To or Equal To Start Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        this.preTask.FinishTime = '';
        this.preTaskForm.patchValue({ finishTime: null });
        return;
      }

      if (finishTime > currentTime) {
        this.toastr.warning(
          'Finish Time Should Not Be Greater Than Current Time',
          'Warning',
          {
            timeOut: 3000,
          }
        );
        this.preTask.FinishTime = '';
        this.preTaskForm.patchValue({ finishTime: null });
        return;
      }
      this.preTask.FinishTime = finishTime.toISOString();

      this.getChecklistData();
    }
  }

  onRemarksChange(newValue: string) {
    if (newValue) {
      this.getChecklistData();
    }
  }

  getCompletionColor(percentage: number): string {
    if (percentage < 50) return 'red';
    else if (percentage < 70) return 'orange';
    else return 'green';
  }

  // GetQualityCheckListExecPMData(checklistIds: any, taskId: any) {
  //   this.spinner.show();
  //   const payload = {
  //     PlantCode: this.plantSession?.plantCode,
  //     ChecklistIds: checklistIds,
  //     TaskId: taskId,
  //   };
  //   this.PrevConfigurationService.getQualityCheckListExecPMData(
  //     payload
  //   ).subscribe({
  //     next: (data) => {
  //       this.spinner.hide();
  //       this.PrevConfigurationService.setChecklistExecPMData(data);
  //     },
  //     error: (error) => {
  //       this.spinner.hide();
  //       this.toaster.error('Error', error.ErrorMessage);
  //     },
  //   });
  // }

  GetQualityCheckListExecPMData(checklistIds: any, taskId: any): void {
    this.spinner.show();

    const payload = {
      PlantCode: this.plantSession?.plantCode,
      ChecklistIds: checklistIds,
      TaskId: taskId,
    };

    this.PrevConfigurationService.getQualityCheckListExecPMData(
      payload
    ).subscribe({
      next: (data) => {
        this.spinner.hide();
        this.PrevConfigurationService.setChecklistExecPMData(data);
      },
      error: (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error?.ErrorMessage || 'Failed to load');
      },
    });
  }
}
